import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { jsx as _jsx } from "react/jsx-runtime";
const withGateFork = ({
  NewComponent,
  LegacyComponent,
  gateKey
}) => {
  const GateFork = _ref => {
    let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
    const hasGateKey = props[gateKey];
    if (hasGateKey) {
      return /*#__PURE__*/_jsx(NewComponent, Object.assign({}, props));
    }
    return /*#__PURE__*/_jsx(LegacyComponent, Object.assign({}, props));
  };
  GateFork.displayName = `withGateFork(${(NewComponent === null || NewComponent === void 0 ? void 0 : NewComponent.displayName) || (LegacyComponent === null || LegacyComponent === void 0 ? void 0 : LegacyComponent.displayName)})`;
  return GateFork;
};
export default withGateFork;